document.addEventListener('DOMContentLoaded', function () {

  // Qua Shopify App Proxy -> Shopify ký kèm logged_in_customer_id (chống IDOR).
  const customApiDomain = '/apps/artonis';

  const Toast = Swal.mixin({
    toast: true,
    customClass: {
      container: 'app-toast-swal',
      title: 'app-toast--title'
    },
    width: 'fit-content',
    position: "top-end",
    icon: "success",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    }
  });
  
  // Function to add product to wishlist
  function addToWishlist(productId, button) {
    let customerId = localStorage.getItem('app-cid');
    if(!customerId) return;
    fetch(customApiDomain + '/api/wishlist', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'X-CSRF-Token': '{{ form_authenticity_token }}'
      },
      body: JSON.stringify({
        customer_id: customerId,
        product_id: productId
      })
    })
      .then(response => response.json())
      .then(data => {
        if (button) {
          button.classList.remove('add_to_wishlist');
          button.classList.add('remove_from_wishlist');
        }
        Toast.fire({
          title: "Product added to your wishlist!"
        });
      })
      .catch(error => {
        console.log('This product is already in your wishlist.');
      });
    
    
  }
  
  // Function to remove product from wishlist
  function removeFromWishlist(productId, button) {
    let customerId = localStorage.getItem('app-cid');
    if(!customerId) return;
    
    fetch(customApiDomain + `/api/wishlist/${customerId}/${productId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'X-CSRF-Token': '{{ form_authenticity_token }}'
      },
      body: null
    })
      .then(response => response.json())
      .then(data => {
        
        if (button) {
          button.classList.remove('remove_from_wishlist');
          button.classList.add('add_to_wishlist');
        }
        
        Toast.fire({
          title: "Product removed from your wishlist!"
        });
        
      })
      .catch(error => {
        console.erorr('Product cannot remove from your wishlist.');
      });
    
  }
  
  // Event listener for Add to Wishlist buttons
  document.querySelectorAll('.wishlist_button').forEach(function (button) {
    button.addEventListener('click', function () {
      const productId = this.getAttribute('data-product-id');
      
      let customerId = localStorage.getItem('app-cid');
      if (!customerId) {
        Swal.fire({
          title: "Please log in to add products to your wishlist",
          // text: "You need to be logged in to save items.",
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: "Login",
          denyButtonText: "Close"
        }).then((result) => {
          if (result.isConfirmed) {
            window.open('/account/login', '_blank');
          }
        });
        return;
      }
      
      if (button.classList.contains('add_to_wishlist')) {
        addToWishlist(productId, button);
      }
      
      
      if (button.classList.contains('remove_from_wishlist')) {
        removeFromWishlist(productId, button);
      }
      
      
    });
  });
  
  
});